import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../redux/Authentication";
import { DateTimeFormater } from '../services/Helper';
import './style.css';
import { selectUser } from '../redux/selector';
import { useSelector } from 'react-redux';
import toast, { Toaster } from "react-hot-toast";
import Notifications from './Notifications';
import usePermissionCheck from '../hooks/usePermissionCheck';

const Header = () => {
  const user = useSelector(selectUser);
  const canViewNotifications = usePermissionCheck(["general.notifications"]);

  let navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async (e) => {
    const id = localStorage.getItem("token");
    const logouts = await localStorage.removeItem("token");
    dispatch(logout());
    navigate("/login");
  };
  
  return (
    <>
    <Toaster position="top-center" reverseOrder={false} />
    <header className="main-header bg-body position-relative d-none d-xl-block px-10 py-6">
      <div className="container-fluid">
        <nav className="navbar navbar-light py-0 row no-gutters px-3 px-lg-0">
          <div className="col-md-4 px-0 px-md-6 order-1 order-md-0">

          </div>
          <div className="col-md-6 d-flex flex-wrap justify-content-md-end align-items-center order-0 order-md-1">
            {canViewNotifications && <Notifications />}
            <div className="dropdown pl-2 py-2">
              <a href="#" className="dropdown-toggle text-heading pr-3 pr-sm-6 d-flex align-items-center justify-content-end" data-bs-toggle="dropdown">
              <div
              className="initials-avatar"
              style={{
                width: 50,
                height: 50,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#4e7661',
                color: '#fff',
                fontSize: '1.5rem',
              }}
            >
              {user?.firstname?.[0]}{user?.lastname?.[0]}
              
            </div>
              </a>
              <div className="dropdown-menu dropdown-menu-end w-100">
                <a className="dropdown-item" href="/profile">My Profile</a>
                <a className="dropdown-item" onClick={handleLogout}>Logout</a>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>

    </>
  )
}

export default Header